import { ssnRegex } from '@dermloop/regular-expressions';
import { Type } from 'class-transformer';
import {
  IsDate,
  IsNotEmpty,
  IsObject,
  IsOptional,
  IsString,
  IsUUID,
  Matches,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
/** Identity of a destination patient that does not exist in Dermloop yet. */
export class MoveConditionNewPatientDto {
  @ValidateIf((patient) => patient.ssn != null || !patient.mrn)
  @Matches(ssnRegex, { message: 'Not a valid CPR number' })
  ssn?: string;

  @ValidateIf((patient) => !patient.ssn)
  @IsNotEmpty()
  @IsString()
  mrn?: string;

  @IsOptional()
  @IsNotEmpty()
  @IsString()
  firstName?: string;

  @IsOptional()
  @IsNotEmpty()
  @IsString()
  lastName?: string;

  @IsOptional()
  @IsDate()
  birthDate?: Date;

  @IsNotEmpty()
  @IsString()
  genderId: string;
}

/** Names the destination by id or, when it does not exist yet, by `newPatient`. */
export class MoveConditionDto {
  @ValidateIf((dto) => !dto.newPatient)
  @IsUUID()
  destinationHealthRecordId?: string;

  @ValidateIf((dto) => !dto.destinationHealthRecordId)
  @IsObject()
  @ValidateNested()
  @Type(() => MoveConditionNewPatientDto)
  newPatient?: MoveConditionNewPatientDto;
}
